import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.promise.js';
import Cookies from 'universal-cookie';
import axios from 'axios';
import 'core-js/modules/es.string.sub.js';
import jwt_decode from 'jwt-decode';
import React, { createElement, Component, useEffect, useState, useCallback, useLayoutEffect } from 'react';
import { MessageBanner, MessageBannerType } from '@amzn/stencil-react-components/message-banner';
import { Text, Label } from '@amzn/stencil-react-components/text';
import { Spinner, SpinnerSize } from '@amzn/stencil-react-components/spinner';
import { useBreakpoints } from '@amzn/stencil-react-components/responsive';
import { Redirect } from 'react-router-dom';
import 'core-js/modules/es.function.name.js';
import { IconStarFill, IconSize, IconStar } from '@amzn/stencil-react-components/icons';
import 'core-js/modules/es.array.for-each.js';
import 'core-js/modules/es.date.now.js';
import 'core-js/modules/es.date.to-iso-string.js';
import 'core-js/modules/es.date.to-string.js';
import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.object.keys.js';
import 'core-js/modules/web.dom-collections.for-each.js';
import KatalLogger, { Level } from '@amzn/katal-logger';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import I18NextHttpBackend from 'i18next-http-backend';
import ICU from 'i18next-icu';
import LanguageDetector from 'i18next-browser-languagedetector';
import languageMap from '@amzn/katal-localization/webpack-loader!';
import { View } from '@amzn/stencil-react-components/layout';
import { Breadcrumbs } from '@amzn/stencil-react-components/breadcrumbs';
import { ButtonVariant, Button } from '@amzn/stencil-react-components/button';
import { styledWithTheme } from '@amzn/stencil-react-components/context';
import 'core-js/modules/es.array.includes.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.object.values.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.includes.js';
import 'core-js/modules/es.string.iterator.js';
import 'core-js/modules/es.string.search.js';
import 'core-js/modules/web.url.js';
import { Expander, ExpanderChevronPosition } from '@amzn/stencil-react-components/expander';

/**
 * Get decoded token for the tokenName provided from cookies.
 * @param tokenName : name of the token to fetch value from Cookies.
 * @returns Decoded token. Returns undefined in case of error.
 */
var getDecodedToken = function getDecodedToken(tokenName) {
  try {
    var jwtToken = new Cookies().get(tokenName);
    return jwt_decode(jwtToken);
  } catch (error) {
    console.error(error);
    return undefined;
  }
};
/**
 * Get employee Id provided by the token from cookies.
 * @param tokenName : name of the token to fetch value from Cookies.
 * @returns Employee Id of the user.
 */
var getEmployeeIdFromJWT = function getEmployeeIdFromJWT(tokenName) {
  var decodedToken = getDecodedToken(tokenName);
  return decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken.sub;
};

var GetHelpIcon = function GetHelpIcon(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? "24" : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? "24" : _ref$height;
  return /*#__PURE__*/React.createElement("svg", {
    "aria-hidden": true,
    width: width,
    height: height,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.50004 0.833374C1.57921 0.833374 0.833374 1.63671 0.833374 2.62837V13.205C0.833374 14.1959 1.57921 15 2.50004 15H6.38921V18.3125C6.38921 19.455 7.62837 20.0784 8.44254 19.3442L13.0817 15H17.5009C18.4217 15 19.1675 14.1967 19.1675 13.205V2.62837C19.1675 1.63754 18.4217 0.833374 17.5009 0.833374H2.50004ZM2.50004 2.50004H17.5V13.3334H13.1817C12.79 13.3334 12.4109 13.3542 12.1109 13.625L8.05587 17.4234V15.0009C8.05504 14.01 7.30837 13.3342 6.38837 13.3342H2.50004V2.50004Z",
    fill: "#1768c9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.11926 11.6983C9.28593 11.865 9.5026 11.9483 9.76926 11.9483C10.0359 11.9483 10.2526 11.865 10.4193 11.6983C10.5859 11.5316 10.6693 11.315 10.6693 11.0483C10.6693 10.7816 10.5859 10.565 10.4193 10.3983C10.2526 10.2316 10.0359 10.1483 9.76926 10.1483C9.5026 10.1483 9.28593 10.2316 9.11926 10.3983C8.9526 10.565 8.86926 10.7816 8.86926 11.0483C8.86926 11.315 8.9526 11.5316 9.11926 11.6983Z",
    fill: "#1768c9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.22918 9.45838C9.26918 9.49172 9.33585 9.50838 9.42918 9.50838H10.0692C10.1625 9.50838 10.2258 9.48838 10.2592 9.44838C10.2992 9.40838 10.3192 9.34505 10.3192 9.25838V8.65838C10.9192 8.34505 11.3525 8.01838 11.6192 7.67838C11.8858 7.33838 12.0192 6.93838 12.0192 6.47838C12.0192 5.93172 11.8392 5.50172 11.4792 5.18838C11.1258 4.87505 10.6325 4.71838 9.99918 4.71838C9.43251 4.71838 8.89251 4.83838 8.37918 5.07838C8.28585 5.11838 8.22585 5.16172 8.19918 5.20838C8.17251 5.24838 8.15918 5.31838 8.15918 5.41838V5.96838C8.15918 6.12172 8.21585 6.19838 8.32918 6.19838C8.38918 6.19838 8.48251 6.17172 8.60918 6.11838C9.00251 5.95838 9.37585 5.87838 9.72918 5.87838C10.0092 5.87838 10.2225 5.94505 10.3692 6.07838C10.5225 6.20505 10.5992 6.38838 10.5992 6.62838C10.5992 6.88838 10.5192 7.11505 10.3592 7.30838C10.2058 7.49505 9.94585 7.68505 9.57918 7.87838L9.27918 8.03838C9.20585 8.07838 9.15251 8.12172 9.11918 8.16838C9.09251 8.20838 9.07918 8.26505 9.07918 8.33838V8.43838C9.08585 8.48505 9.09251 8.53838 9.09918 8.59838L9.15918 9.27838C9.16585 9.36505 9.18918 9.42505 9.22918 9.45838Z",
    fill: "#1768c9"
  }));
};

var cloudFrontURIBeta = "https://atoz-my-hr-app.integ.amazon.work/";
var cloudFrontURI = cloudFrontURIBeta;
var cloudFrontURIProd = "https://atoz-my-hr-app.amazon.work/";
var ATOZ_OAUTH_TOKEN_KEY = "atoz-oauth-token";
var LIVEHELP_AS_A_SERVICE_KEY = "livehelp_as_a_service";
var FLOATER_BUTTON_WIDTH = 44;
var FLOATER_BUTTON_HEIGHT = 44;
var INITIAL_FLOATER_BUTTON_PROPS = {
  icon: /*#__PURE__*/createElement(GetHelpIcon, {
    width: "24",
    height: "24"
  }),
  classname: "",
  onClick: function onClick() {},
  isDraggable: false
};
var FLOATER_BUTTON_STYLE = {
  desktop: {
    rightOffset: 32,
    bottomOffset: 32
  },
  mobile: {
    rightOffset: 16,
    bottomOffset: 16
  }
};
var URL_SEARCH_PARAMETER_KEY_CONSTANTS = {
  CATEGORY: "category",
  TYPE: "type",
  ITEM: "item",
  LANGUAGE: "language",
  CLIENT_ID: "clientId",
  SOURCE_PAGE: "sourcePage"
};
var BANNER_TYPE;
(function (BANNER_TYPE) {
  BANNER_TYPE["INFORMATIONAL"] = "InformationalBanner";
  BANNER_TYPE["ERROR"] = "ErrorBanner";
  BANNER_TYPE["BIAS"] = "BiasBanner";
  BANNER_TYPE["SUCCESS"] = "SuccessBanner";
  BANNER_TYPE["WARNING"] = "WarningBanner";
})(BANNER_TYPE || (BANNER_TYPE = {}));

var STAGE = 'prod';
var Stage;
(function (Stage) {
  Stage["test"] = "test";
  Stage["alpha"] = "alpha";
  Stage["beta"] = "beta";
  Stage["prod"] = "prod";
})(Stage || (Stage = {}));
var stageApiUrl = {
  test: 'https://atoz-api.integ.amazon.com/router',
  alpha: 'https://atoz-api.integ.amazon.com/router',
  beta: 'https://atoz-api.integ.amazon.com/router',
  prod: 'https://atoz-api.amazon.work/router'
};
var BackendServiceClient = /*#__PURE__*/function () {
  function BackendServiceClient(appRoot) {
    if (appRoot) {
      this.appRoot = appRoot;
    }
    axios.defaults.headers = this.setDefaultHeaders();
  }
  /**
   * Send a GET call to downstream dependency through MyHRGatewayService.
   * Sending a POST with null body to AtoZ API delegator triggers a GET call from MyHRGatewayService to downstream.
   * Additional headers cannot be passed. Required headers to be passed to AtoZ delegator are added by default.
   * All the downstream systems must extract their inputs from query parameters when integrating with MyHRGateway service.
   *
   * @param queryParams MANDATORY: MyHR Client ID & path is required, for instance "x-myhr-client-id":"MyHR_LiveHelp". This is based on the configuration added in ApiConfig.json in MyHRGatwayService.
   * Path to be added as "operation":"/sample/path" for your back end service, for instance "operation":"/api/contact/voice".
   * @returns A Promise<AxiosResponse> for the constructed axios request with mandatory headers added.
   */
  var _proto = BackendServiceClient.prototype;
  _proto.get = function get(queryParams) {
    try {
      var _this2 = this;
      var baseUrl = _this2.getApiGatewayUrl();
      var requestConfig = {
        params: queryParams,
        withCredentials: true
      };
      return Promise.resolve(axios.get(baseUrl, requestConfig));
    } catch (e) {
      return Promise.reject(e);
    }
  }
  /**
   * Send a POST call to MyHRGatewayService through AtoZ delegator.
   * Additional headers cannot be passed. Required headers to be passed to AtoZ delegator are added by default.
   * All the downstream systems must extract their inputs from body and/or query parameters when integrating with MyHRGateway service.
   *
   * @param body Body to be passed to your backend service.
   * @param queryParams MANDATORY: MyHR Client ID & path is required, for instance "x-myhr-client-id":"MyHR_LiveHelp". This is based on the configuration added in ApiConfig.json in MyHRGatwayService.
   * Path to be added as "operation":"/sample/path" for your back end service, for instance "operation":"/api/contact/voice".
   * @returns A Promise<AxiosResponse> for the constructed axios POST request with mandatory headers added.
   */
  ;
  _proto.post = function post(body, queryParams) {
    try {
      var _this4 = this;
      var baseUrl = _this4.getApiGatewayUrl();
      var requestConfig = {
        params: queryParams,
        withCredentials: true
      };
      return Promise.resolve(axios.post(baseUrl, body, requestConfig));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  _proto.getApiGatewayUrl = function getApiGatewayUrl() {
    return Stage.beta === STAGE.toLowerCase() || Stage.alpha === STAGE.toLowerCase() ? stageApiUrl[STAGE.toLowerCase()] + "?employeeId=" + this.getEmployeeId() : "" + stageApiUrl[STAGE.toLowerCase()];
  };
  _proto.getEmployeeId = function getEmployeeId() {
    var _document$getElementB, _document$getElementB2;
    var employeeId = this.appRoot ? (_document$getElementB = document.getElementById(this.appRoot)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.dataset.employeeId : (_document$getElementB2 = document.getElementById("atoz-my-hr-app-root")) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.dataset.employeeId;
    if (!employeeId) {
      employeeId = getEmployeeIdFromJWT(ATOZ_OAUTH_TOKEN_KEY);
    }
    return employeeId;
  };
  _proto.setDefaultHeaders = function setDefaultHeaders() {
    return {
      'x-atoz-client-id': 'ATOZ_MYHRGATEWAY_SERVICE',
      Authorization: "Bearer " + new Cookies().get(ATOZ_OAUTH_TOKEN_KEY),
      'Content-Type': 'application/json',
      'x-atoz-client-request-id': "" + localStorage.getItem('x-atoz-client-request-id')
    };
  };
  return BackendServiceClient;
}();

var SegmentationServiceClient = /*#__PURE__*/function () {
  function SegmentationServiceClient() {}
  var _proto = SegmentationServiceClient.prototype;
  /**
   * POST call to segmentation service V2 to fetch employee country code and login.
   * If auth token is not present, call to service is skipped.
   */
  _proto.fetchEmployeeDetails = function fetchEmployeeDetails() {
    try {
      var employeeAttributes;
      var queryParams = {
        "x-myhr-client-id": "MyHR_Segmentation_v2",
        "operation": "/employeeById"
      };
      var body = {
        "x-myhr-client-id": "MyHR_Segmentation_v2"
      };
      var backendServiceClient = new BackendServiceClient();
      return Promise.resolve(backendServiceClient.post(body, queryParams).then(function (result) {
        employeeAttributes = JSON.parse(result.data.response);
        return employeeAttributes;
      })["catch"](function (error) {
        console.error("Error occurred while fetching details from Segmentation service", error);
        throw new Error(error);
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  return SegmentationServiceClient;
}();

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

/**
 * Renders the Error components
 */
var ErrorBanner = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ErrorBanner, _Component);
  function ErrorBanner() {
    var _this;
    _this = _Component.apply(this, arguments) || this;
    _this.render = function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, _this.props.showErrorBanner.isError && /*#__PURE__*/React.createElement(MessageBanner, {
        "aria-live": "polite",
        isDismissible: false,
        type: MessageBannerType.Error
      }, /*#__PURE__*/React.createElement(Text, {
        fontSize: _this.props.fontSize
      }, _this.props.showErrorBanner.message)));
    };
    return _this;
  }
  return ErrorBanner;
}(Component);

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".suspense-loader{align-items:center;display:flex;justify-content:center;margin:10rem auto}";
styleInject(css_248z);

/**
 * Component to display a loading section prior to loading a
 * component.
 */
var SuspenseLoader = function SuspenseLoader() {
  var _useBreakpoints = useBreakpoints(),
    matches = _useBreakpoints.matches;
  return /*#__PURE__*/React.createElement("div", {
    className: "suspense-loader"
  }, /*#__PURE__*/React.createElement(Spinner, {
    size: matches.s ? SpinnerSize.Small : SpinnerSize.Medium
  }));
};

/**
 * Redirect to the component present on pathName
 */
var RedirectToComponent = /*#__PURE__*/function (_Component) {
  _inheritsLoose(RedirectToComponent, _Component);
  function RedirectToComponent() {
    var _this;
    _this = _Component.apply(this, arguments) || this;
    _this.render = function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Redirect, {
        push: !_this.props.shouldReplaceHistory,
        to: {
          pathname: _this.props.path,
          state: {
            propsToPass: _this.props.propsToPass
          }
        }
      }));
    };
    return _this;
  }
  return RedirectToComponent;
}(Component);

var css_248z$1 = ".custom-ratings-button{-webkit-appearance:none;-moz-appearance:none;appearance:none}.custom-ratings-button:active+label,.custom-ratings-button:focus+label,.custom-ratings-button:focus-visible+label{border:2px solid #b78e06}.visually-hidden{clip:rect(1px,1px,1px,1px)!important;border:0!important;-webkit-clip-path:inset(50%)!important;clip-path:inset(50%)!important;height:1px!important;margin:-1px!important;overflow:hidden!important;padding:0!important;position:absolute!important;white-space:nowrap!important;width:1px!important}";
styleInject(css_248z$1);

var RatingsButton = function RatingsButton(_ref) {
  var name = _ref.name,
    labelText = _ref.labelText,
    id = _ref.id,
    handleOnClick = _ref.handleOnClick,
    _ref$filled = _ref.filled,
    filled = _ref$filled === void 0 ? false : _ref$filled;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    name: name,
    id: id,
    onClick: handleOnClick,
    className: "custom-ratings-button"
  }), /*#__PURE__*/React.createElement(Label, {
    margin: {
      right: "8px"
    },
    htmlFor: id
  }, filled ? /*#__PURE__*/React.createElement(IconStarFill, {
    size: IconSize.Small,
    color: "#B78E06"
  }) : /*#__PURE__*/React.createElement(IconStar, {
    size: IconSize.Small,
    color: "#B78E06"
  }), /*#__PURE__*/React.createElement("span", {
    className: "visually-hidden"
  }, labelText)));
};

var LogUtils = /*#__PURE__*/function () {
  function LogUtils() {}
  var _proto = LogUtils.prototype;
  /**
   * records current timestamp in ISO format
   */
  _proto.recordCurrentTimestampISO = function recordCurrentTimestampISO() {
    return new Date(Date.now()).toISOString();
  };
  return LogUtils;
}();
var MyHRLogger = /*#__PURE__*/function (_KatalLogger) {
  _inheritsLoose(MyHRLogger, _KatalLogger);
  function MyHRLogger(config) {
    var _this;
    _this = _KatalLogger.call(this, config) || this;
    _this.getDimensionStructure = function (dimension) {
      var dimensionNames = [];
      var dimensionValues = {};
      dimension === null || dimension === void 0 ? void 0 : dimension.forEach(function (group) {
        var dimensionName = Object.keys(group);
        dimensionNames.push(dimensionName);
        Object.keys(group).forEach(function (record) {
          dimensionValues[record] = group[record];
        });
      });
      return {
        dimensionNames: dimensionNames,
        dimensionValues: dimensionValues
      };
    };
    /**
     * method used to log data into cloudwatch and sent to myHR data pipeline
     * @param myHRDataPipeline
     */
    _this.myHRDataPipelineLogInfo = function (myHRDataPipeline) {
      try {
        var log = {
          datasetName: myHRDataPipeline.datasetName,
          schemaVersion: myHRDataPipeline.schemaVersion ? myHRDataPipeline.schemaVersion : 1,
          records: myHRDataPipeline.records
        };
        var requestId = localStorage.getItem('x-atoz-client-request-id');
        if (requestId !== null) log["x-atoz-client-request-id"] = requestId;
        var res;
        try {
          res = _this.info("myhr-data-pipeline", log);
        } catch (error) {
          console.log("error in katal logger", error);
          // @ts-ignore
          throw new Error(error.message);
        }
        return Promise.resolve(res);
      } catch (e) {
        return Promise.reject(e);
      }
    };
    /**
     * method used to log data into cloudwatch for debugging
     * @param myHRLogDebugLogString
     */
    _this.myHRLogDebugInfo = function (myHRLogDebugLogString) {
      try {
        var log = {};
        var requestId = localStorage.getItem('x-atoz-client-request-id');
        if (requestId !== null) log["x-atoz-client-request-id"] = requestId;
        var res;
        try {
          res = _this.info(myHRLogDebugLogString, log);
        } catch (error) {
          console.log("error in katal logger", error);
          // @ts-ignore
          throw new Error(error.message);
        }
        return Promise.resolve(res);
      } catch (e) {
        return Promise.reject(e);
      }
    };
    _this.createEmfLog = function (_ref) {
      var _Object$assign;
      var metricName = _ref.metricName,
        metricValue = _ref.metricValue,
        metricUnit = _ref.metricUnit,
        dimensions = _ref.dimensions,
        _ref$namespace = _ref.namespace,
        namespace = _ref$namespace === void 0 ? 'AtoZMyHRApp' : _ref$namespace;
      var allDimensions = _this.getDimensionStructure(dimensions);
      var emfLog = Object.assign({
        _aws: {
          Timestamp: Date.now(),
          CloudWatchMetrics: [{
            Namespace: namespace,
            Dimensions: allDimensions.dimensionNames,
            Metrics: [{
              Name: metricName,
              Unit: metricUnit
            }]
          }]
        }
      }, allDimensions.dimensionValues, (_Object$assign = {}, _Object$assign[metricName] = metricValue, _Object$assign["x-atoz-client-request-id"] = localStorage.getItem('x-atoz-client-request-id'), _Object$assign));
      return emfLog;
    };
    /**
     * Logs an EMF metric using the Katal logger (with EMF payload added to the log)
     */
    _this.logEmfMetric = function (metricPayload) {
      var emfLog = _this.createEmfLog(metricPayload);
      return _this.info(metricPayload.metricName, {
        emfLog: emfLog
      });
    };
    _this.logUtils = new LogUtils();
    return _this;
  }
  return MyHRLogger;
}(KatalLogger);

var loggerConfig = {
  url: 'https://atoz-my-hr-katal.amazon.work/v1/log',
  logThreshold: Level.DEBUG,
  maxLogLineSize: 10001,
  logToConsole: false,
  decodeStackTrace: true,
  headers: {
    "Accept-Language": "*"
  }
};

/**
 * Token key used to represent suppress actions for unload popups.
 */
var UNLOAD_SUPPRESS_TOKEN_KEY = 'unload-suppress-token';
/**
 * Re-direct to the given URL.
 * @param url The URL the page to be redirected to
 */
function redirectTo(url) {
  // Set token in session storage to suppress reload popups
  sessionStorage.setItem(UNLOAD_SUPPRESS_TOKEN_KEY, 'true');
  window.location.href = url;
}
function browserBack() {
  window.history.back();
}
/**
 * Get preferred language from the i18nextLng stored by AtoZ.
 * In local testing, i18nextLng is not set, thus returning a default value.
 * @returns Selected preferred language by user. Defaults to "en-US" if unavailable.
 */
function fetchPreferredLanguage() {
  var preferredLanguage = localStorage.getItem("i18nextLng");
  return preferredLanguage == null ? "en-US" : preferredLanguage;
}
/**
 * Custom hook to set the document title when the component is mounted and reverts to previous when it unmounts
 * Note: Only works for functional components
 */
function useTitle(title) {
  useEffect(function () {
    var prevTitle = document.title;
    document.title = title;
    return function () {
      document.title = prevTitle;
    };
  });
}
/**
 * @template liesInRange : checks whether provided number is in between lower and upper bound (inclusive)
 * @param value : actual value received can be number
 * @param lowerBound : lower bound number value inclusive
 * @param upperBound : upper bound number value inclusive
 * @returns : boolean
 */
function liesInRange(value, lowerBound, upperBound) {
  if (value === undefined) {
    return false;
  }
  return value >= lowerBound && value <= upperBound;
}
/**
 * @function getBannerType from the bannerType string
 * @param bannerType
 */
var getBannerType = function getBannerType(bannerType) {
  switch (bannerType) {
    case BANNER_TYPE.INFORMATIONAL:
      return MessageBannerType.Informational;
    case BANNER_TYPE.ERROR:
      return MessageBannerType.Error;
    case BANNER_TYPE.BIAS:
      return MessageBannerType.Bias;
    case BANNER_TYPE.SUCCESS:
      return MessageBannerType.Success;
    case BANNER_TYPE.WARNING:
      return MessageBannerType.Warning;
    default:
      return MessageBannerType.Error;
  }
};

// If initialization is complete, the last error, if any
var initializationError;
// Registered callbacks for when i18n initialization completes
var i18nInitializationCallbacks = [];
var newI18NInstance = /*#__PURE__*/i18n.createInstance();
newI18NInstance.use(I18NextHttpBackend).use(ICU).use(LanguageDetector).use(initReactI18next).init({
  debug: process.env.NODE_ENV !== 'production',
  fallbackLng: 'en-US',
  interpolation: {
    // not needed for react as it escapes by default
    escapeValue: false
  },
  load: 'currentOnly',
  backend: {
    loadPath: function loadPath(localeList) {
      return languageMap[localeList[0]];
    }
  },
  detection: {
    // order and from where user language should be detected
    order: ['htmlTag', 'navigator']
  }
}, function (err) {
  initializationError = err;
  i18nInitializationCallbacks.forEach(function (callback) {
    callback(initializationError);
  });
  i18nInitializationCallbacks.length = 0;
});
// @ts-ignore
newI18NInstance.on('languageChanged', function (lng) {
  // We must manually translate the title of the page, unless this is
  // a Mons app, in which case the title is handled by Seller Central.
  var titleEl = document.querySelector('#app-title');
  if (titleEl) {
    titleEl.innerText = i18n.t('sample_app_page_title_text');
  }
});

var getDefaultI18nInitOptions = function getDefaultI18nInitOptions(locales, namespace) {
  return {
    fallbackLng: ['en-US'],
    debug: false,
    ns: [namespace],
    fallbackNS: namespace,
    resources: locales,
    // react i18next special options (optional)
    // https://react.i18next.com/components/i18next-instance
    react: {
      bindI18n: 'languageChanged loaded',
      bindStore: 'added removed',
      nsMode: 'fallback',
      useSuspense: true
    }
  };
};
//Use this to create i18 instance in your package
var newi18instance = function newi18instance(locales, namespace) {
  if (namespace === void 0) {
    namespace = 'atoz_myhr_app';
  }
  var newI18nInstance = newI18NInstance.createInstance();
  var options = getDefaultI18nInitOptions(locales, namespace);
  newI18nInstance.use(initReactI18next).init(options);
  return newI18nInstance;
};

var css_248z$2 = ".nlc-crumb-view{padding:0!important}.crumbViewCursor-l{color:#1768c9;cursor:pointer;font-size:2rem!important}.crumbViewCursor-m{color:#1768c9;cursor:pointer;font-size:1.5rem!important}.crumbView-l{color:#232f3e;font-size:2rem!important}.crumbView-m{color:#232f3e;font-size:1.5rem!important}.nlc-crumb-icon-col-l{align-items:flex-end;margin-top:.9rem!important;width:5%}.nlc-crumb-icon-col-s{align-items:flex-end;margin-top:.35rem!important;width:5%}.breadcrumbs-ul{display:flex;list-style-type:none;margin:0!important;padding:0!important;width:100%}.breadcrumbs-ol-l a,.breadcrumbs-ol-l span{font-size:1.8rem!important}.breadcrumbs-ol-l a{color:#1768c9!important}.breadcrumbs-ol-m a,.breadcrumbs-ol-m span{font-size:1.8rem!important}.breadcrumbs-ol-m a{color:#1768c9!important}";
styleInject(css_248z$2);

/**
 * This is component is responsible for showing crumbs
 */
var CustomBreadcrumbs = function CustomBreadcrumbs(_ref) {
  var crumbs = _ref.crumbs,
    backgroundColor = _ref.backgroundColor;
  var _useBreakpoints = useBreakpoints(),
    matches = _useBreakpoints.matches;
  return /*#__PURE__*/React.createElement(View, {
    className: matches.m ? 'breadcrumbs-ol-m' : 'breadcrumbs-ol-l',
    style: {
      backgroundColor: backgroundColor
    }
  }, /*#__PURE__*/React.createElement(Breadcrumbs, {
    crumbs: crumbs
  }));
};

var AdobeOmnitureBuilder = /*#__PURE__*/function () {
  function AdobeOmnitureBuilder(pageName, subPageName, hitType, pageAction, pageConst, refTag, referrer) {
    this.pageName = pageName;
    this.subPageName = subPageName ? subPageName : AdobeOmnitureBuilder.DEFAULT_VALUE;
    this.hitType = hitType ? hitType : AdobeOmnitureBuilder.DEFAULT_VALUE;
    this.pageAction = pageAction ? pageAction : AdobeOmnitureBuilder.DEFAULT_VALUE;
    this.pageConst = pageConst ? pageConst : AdobeOmnitureBuilder.DEFAULT_VALUE;
    this.refTag = refTag ? refTag : AdobeOmnitureBuilder.DEFAULT_VALUE;
    this.referrer = referrer ? referrer : AdobeOmnitureBuilder.DEFAULT_VALUE;
  }
  var _proto = AdobeOmnitureBuilder.prototype;
  _proto.build = function build() {
    var prevPageName = AdobeOmnitureBuilder.prevPageName;
    AdobeOmnitureBuilder.prevPageName = this.pageName;
    return {
      pageName: this.pageName,
      eVar44: this.subPageName,
      eVar45: this.pageAction,
      eVar46: this.pageConst,
      eVar47: this.hitType,
      prop31: this.refTag,
      prop27: prevPageName,
      referrer: this.referrer
    };
  };
  return AdobeOmnitureBuilder;
}();
AdobeOmnitureBuilder.DEFAULT_VALUE = '';
var OmnitureHelper = /*#__PURE__*/function () {
  function OmnitureHelper() {}
  /**
   * Call Omniture to update the metrics for page information
   */
  OmnitureHelper.setOmnitureInfo = function setOmnitureInfo(pageInfo) {
    if (OmnitureHelper.hasOmniture(window)) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      var omniture = window.s;
      omniture.t(pageInfo);
    }
  }
  /**
   * Determine if the current window has omniture js available
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ;
  OmnitureHelper.hasOmniture = function hasOmniture(window) {
    return window.s != null;
  };
  return OmnitureHelper;
}();
OmnitureHelper.HitTypes = {
  PageHit: '1',
  Redirect: '2',
  Popup: '3',
  Action: '4'
};

var WebAnalytics = /*#__PURE__*/function () {
  function WebAnalytics() {}
  WebAnalytics.sendOmnitureMetric = function sendOmnitureMetric(_ref) {
    var pageName = _ref.pageName,
      subPageName = _ref.subPageName,
      hitType = _ref.hitType,
      pageAction = _ref.pageAction,
      pageConst = _ref.pageConst,
      refTag = _ref.refTag,
      referrer = _ref.referrer;
    OmnitureHelper.setOmnitureInfo(new AdobeOmnitureBuilder(pageName, subPageName, hitType, pageAction, pageConst, refTag, referrer).build());
  };
  return WebAnalytics;
}();

/**
 * Renders the Message Banner components
 */
var MessageBannerComponent = /*#__PURE__*/function (_Component) {
  _inheritsLoose(MessageBannerComponent, _Component);
  function MessageBannerComponent() {
    var _this;
    _this = _Component.apply(this, arguments) || this;
    _this.render = function () {
      var showMessageBanner = _this.props.showMessageBanner;
      return /*#__PURE__*/React.createElement(React.Fragment, null, showMessageBanner.containsMessage && /*#__PURE__*/React.createElement(MessageBanner, {
        "aria-live": "polite",
        isDismissible: false,
        type: showMessageBanner.type
      }, /*#__PURE__*/React.createElement(Text, {
        fontSize: 'T400',
        fontWeight: "bold"
      }, /*#__PURE__*/React.createElement(Text, {
        dangerouslySetInnerHTML: {
          __html: showMessageBanner.message
        }
      }))));
    };
    return _this;
  }
  return MessageBannerComponent;
}(Component);

/**
 * @function getWindowDimensions
 * @returns window dimensions
 */
function getWindowDimensions() {
  var _window = window,
    width = _window.innerWidth,
    height = _window.innerHeight;
  return {
    width: width,
    height: height
  };
}
/**
 *
 * @function useWindowDimensions
 * @returns { width , height } where width and height keys depicting respective dimensions of window
 */
var useWindowDimensions = function useWindowDimensions() {
  var _useState = useState(getWindowDimensions()),
    windowDimensions = _useState[0],
    setWindowDimensions = _useState[1];
  useEffect(function () {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  return windowDimensions;
};

/**
 * @function useScrollLock
 * @returns object consisting of below functions
 *  @function blockScroll : helps to block the page scroll both horizonatal and vertical
 *  @function unBlockScroll : unblock scroll
 *
*/
function useScrollLock() {
  var propertyId = '--scroll-control-livehelp-team';
  var _useWindowDimensions = useWindowDimensions(),
    width = _useWindowDimensions.width;
  var blockScroll = useCallback(function () {
    document.body.style.overflow = "hidden";
    document.body.style.paddingRight = "var(" + propertyId + ")";
  }, []);
  var unBlockScroll = useCallback(function () {
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
    delete document.body.dataset.scrollLock;
  }, []);
  useLayoutEffect(function () {
    var scrollOffset = width - document.body.offsetWidth;
    document.body.style.setProperty(propertyId, scrollOffset + "px");
  }, []);
  return {
    blockScroll: blockScroll,
    unBlockScroll: unBlockScroll
  };
}

var css_248z$3 = ".floater-text{display:inline-block;font-size:16px;font-weight:500;overflow:hidden;padding-left:5px;white-space:nowrap}";
styleInject(css_248z$3);

var _templateObject;
var FloaterButtonView = /*#__PURE__*/styledWithTheme(Button)(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    display: flex;\n    min-width: 44px !important;\n    min-height: 44px !important;\n    max-height: 44px !important;\n    width: ", "px !important;\n    position: fixed;\n    box-shadow:  0px 1px 10px rgba(35, 47, 62, 0.2);\n    flex-flow: row;\n    padding: 0px 0px 0px 0px;\n    z-index: ", ";\n"])), FLOATER_BUTTON_WIDTH, function (_ref) {
  var theme = _ref.theme;
  return theme.selectors.zIndex("flyout") - 1;
});
var FloaterButton = function FloaterButton(floaterButtonProps) {
  var _floaterButtonProps$s;
  var finalFloaterButtonProps = Object.assign({}, INITIAL_FLOATER_BUTTON_PROPS, floaterButtonProps);
  var icon = finalFloaterButtonProps.icon,
    style = finalFloaterButtonProps.style,
    onClick = finalFloaterButtonProps.onClick,
    classname = finalFloaterButtonProps.classname,
    isDraggable = finalFloaterButtonProps.isDraggable;
  var _useBreakpoints = useBreakpoints(),
    matches = _useBreakpoints.matches;
  var _useWindowDimensions = useWindowDimensions(),
    width = _useWindowDimensions.width,
    height = _useWindowDimensions.height;
  var _useScrollLock = useScrollLock(),
    blockScroll = _useScrollLock.blockScroll,
    unBlockScroll = _useScrollLock.unBlockScroll;
  var isMobile = matches.s;
  var initialDragState = useCallback(function () {
    var _style$rightOffset, _style$bottomOffset;
    var mobile = FLOATER_BUTTON_STYLE.mobile,
      desktop = FLOATER_BUTTON_STYLE.desktop;
    return {
      rightOffset: (_style$rightOffset = style === null || style === void 0 ? void 0 : style.rightOffset) !== null && _style$rightOffset !== void 0 ? _style$rightOffset : isMobile ? mobile.rightOffset : desktop.rightOffset,
      bottomOffset: (_style$bottomOffset = style === null || style === void 0 ? void 0 : style.bottomOffset) !== null && _style$bottomOffset !== void 0 ? _style$bottomOffset : isMobile ? mobile.bottomOffset : desktop.bottomOffset,
      clickAllowed: true
    };
  }, [style === null || style === void 0 ? void 0 : style.rightOffset, style === null || style === void 0 ? void 0 : style.bottomOffset]);
  var _useState = useState(false),
    pressed = _useState[0],
    setPressed = _useState[1];
  var _useState2 = useState(initialDragState()),
    dragState = _useState2[0],
    _setDragState = _useState2[1];
  var setDragState = function setDragState(newDragState) {
    _setDragState(function (prevDragState) {
      return Object.assign({}, prevDragState, newDragState);
    });
  };
  var onClickAndHold = function onClickAndHold() {
    setPressed(true);
    if (isDraggable) {
      blockScroll();
    }
    setDragState({
      clickAllowed: true
    });
  };
  var onUnHold = function onUnHold() {
    setPressed(false);
    if (isDraggable) {
      unBlockScroll();
    }
  };
  var onMovingFloaterButton = function onMovingFloaterButton(e) {
    if (isDraggable) {
      disableEventPropagation(e);
      var newRightOffset = dragState.rightOffset;
      var newBottomOffset = dragState.bottomOffset;
      /**
       * @remarks
       * Change in X and Y coordinate of floater button
       */
      var delta = {
        x: 0,
        y: 0
      };
      if (isMobile) {
        var event = typeof e.originalEvent === 'undefined' ? e : e === null || e === void 0 ? void 0 : e.originalEvent;
        if (event.touches) {
          var touch = event.touches[0] || event.changedTouches[0];
          delta.x = width - touch.clientX;
          delta.y = height - touch.clientY;
        }
      } else {
        delta.x = -e.movementX;
        delta.y = -e.movementY;
      }
      if (newRightOffset && newBottomOffset) {
        newRightOffset += delta.x;
        newBottomOffset += delta.y;
      }
      var isValidXCoordinate = liesInRange(newRightOffset, 0, width - FLOATER_BUTTON_WIDTH);
      var isValidYCoordinate = liesInRange(newBottomOffset, 0, height - FLOATER_BUTTON_HEIGHT);
      if (pressed && isValidXCoordinate && isValidYCoordinate) {
        setDragState({
          rightOffset: newRightOffset,
          bottomOffset: newBottomOffset,
          clickAllowed: Math.abs(delta.x) < 1 && Math.abs(delta.y) < 1
        });
      }
    }
  };
  // disabling event propagation to parent dom elements
  var disableEventPropagation = function disableEventPropagation(e) {
    if (e.stopPropagation) {
      e.stopPropagation();
    }
    if (e.preventDefault && !isMobile) {
      e.preventDefault();
    }
    e.cancelBubble = true;
  };
  var handleClick = function handleClick(e) {
    if (dragState.clickAllowed) {
      onClick(e);
    }
  };
  useEffect(function () {
    setDragState(initialDragState());
  }, [width]);
  return /*#__PURE__*/React.createElement(FloaterButtonView, {
    role: "button",
    className: classname,
    tabIndex: 0,
    icon: icon,
    variant: ButtonVariant.Secondary,
    onKeyPress: handleClick,
    onClick: handleClick,
    style: {
      right: dragState.rightOffset + "px",
      bottom: dragState.bottomOffset + "px",
      zIndex: "" + ((_floaterButtonProps$s = floaterButtonProps.style) === null || _floaterButtonProps$s === void 0 ? void 0 : _floaterButtonProps$s.zIndex)
    },
    onMouseMove: onMovingFloaterButton,
    onMouseDown: onClickAndHold,
    onMouseUp: onUnHold,
    onMouseLeave: onUnHold,
    onTouchMove: onMovingFloaterButton,
    onTouchStart: onClickAndHold,
    onTouchEnd: onUnHold,
    onTouchCancel: onUnHold
  });
};

var getIsLiveHelpAsAService = function getIsLiveHelpAsAService() {
  return sessionStorage.getItem(LIVEHELP_AS_A_SERVICE_KEY) === "true";
};
/**
 * Fetch clientId from query params. Returns null if clientId is invalid or not present in query params.
 * @return clientId unique id of the client
 */
var getClientIdFromQueryParam = function getClientIdFromQueryParam() {
  var search = window.location.search;
  var queryParams = new URLSearchParams(search);
  var clientId = queryParams.get(URL_SEARCH_PARAMETER_KEY_CONSTANTS.CLIENT_ID);
  if (clientId && Object.values(LaasClientId).includes(clientId)) {
    return clientId;
  }
  return null;
};
/**
 * Fetch source page from query params. Returns null if source page is not present in query params.
 * @return sourcePage pageName where livehelp journey was initiated
 */
var getSourcePageFromQueryParam = function getSourcePageFromQueryParam() {
  var search = window.location.search;
  var queryParams = new URLSearchParams(search);
  return queryParams.get(URL_SEARCH_PARAMETER_KEY_CONSTANTS.SOURCE_PAGE);
};
var LaasClientId;
(function (LaasClientId) {
  LaasClientId["MY_HR"] = "MyHR";
  LaasClientId["ATOZ"] = "AtoZ";
  LaasClientId["UTA"] = "UTA";
})(LaasClientId || (LaasClientId = {}));

var colors;
(function (colors) {
  colors["NEUTRAL_100"] = "#161E2D";
  colors["NEUTRAL_80"] = "#394451";
  colors["NEUTRAL_10"] = "#E8EAEE";
  colors["NEUTRAL_0"] = "#ffffff";
  colors["PRIMARY_70"] = "#1768C9";
  colors["PRIMARY_80"] = "#1659A9";
})(colors || (colors = {}));
var ExpanderTextStyle = {
  cursor: "pointer",
  color: colors.PRIMARY_70,
  ":hover": {
    color: colors.PRIMARY_80
  },
  fontWeight: 400
};
var ExpanderTextDesktopStyle = /*#__PURE__*/Object.assign({}, ExpanderTextStyle, {
  fontSize: "1.8rem",
  lineHeight: "2.8rem"
});
var ExpanderTextMobileStyle = /*#__PURE__*/Object.assign({}, ExpanderTextStyle, {
  fontSize: "1.6rem",
  lineHeight: "2.4rem"
});
var ExpanderTextStyleConfigMap = {
  s: ExpanderTextMobileStyle,
  m: ExpanderTextMobileStyle,
  "default": ExpanderTextDesktopStyle
};

// Expander component with props as title of the tile and child component to be shown
var ExpanderComponent = function ExpanderComponent(_ref) {
  var childComponent = _ref.childComponent,
    titleText = _ref.titleText;
  var _useBreakpoints = useBreakpoints({
      propsMap: ExpanderTextStyleConfigMap
    }),
    responsiveStyle = _useBreakpoints.props;
  // Render the title tile
  var renderTile = function renderTile(_ref2) {
    var titleText = _ref2.titleText,
      toggle = _ref2.toggle;
    return /*#__PURE__*/React.createElement(Text, {
      "aria-hidden": true,
      onClick: toggle,
      style: responsiveStyle
    }, titleText);
  };
  // Return the Expander component
  return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Expander, {
    contentSpacing: "S100",
    chevronPosition: ExpanderChevronPosition.Trailing,
    renderTitle: renderTile,
    titleText: titleText
  }, childComponent)));
};

var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ErrorBoundary, _React$Component);
  function ErrorBoundary(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      hasError: false
    };
    return _this;
  }
  /**
   * @function getDerivedStateFromError - function updates state to render Error UI
   * @returns - returns updated state
   */
  ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  /**
   * @function componentDidCatch - function to log errors to cloudwatch and redirect user to error page
   * @param error - minor info on error
   */;
  ErrorBoundary.componentDidCatch = function componentDidCatch(error) {
    console.error('LOG_DEBUG: error: ', error);
  };
  var _proto = ErrorBoundary.prototype;
  _proto.render = function render() {
    if (this.state.hasError) {
      var errorBannerDetail = {
        isError: true,
        message: "Something went wrong"
      };
      return /*#__PURE__*/React.createElement(ErrorBanner, {
        showErrorBanner: errorBannerDetail
      });
    }
    return this.props.children;
  };
  return ErrorBoundary;
}(React.Component);

export { ATOZ_OAUTH_TOKEN_KEY, AdobeOmnitureBuilder, BANNER_TYPE, BackendServiceClient, CustomBreadcrumbs, ErrorBanner, ErrorBoundary, ExpanderComponent, FLOATER_BUTTON_HEIGHT, FLOATER_BUTTON_STYLE, FLOATER_BUTTON_WIDTH, FloaterButton, GetHelpIcon, INITIAL_FLOATER_BUTTON_PROPS, LIVEHELP_AS_A_SERVICE_KEY, LaasClientId, MessageBannerComponent, MyHRLogger, OmnitureHelper, RatingsButton, RedirectToComponent, SegmentationServiceClient, Stage, SuspenseLoader, URL_SEARCH_PARAMETER_KEY_CONSTANTS, WebAnalytics, browserBack, cloudFrontURI, cloudFrontURIBeta, cloudFrontURIProd, fetchPreferredLanguage, getBannerType, getClientIdFromQueryParam, getIsLiveHelpAsAService, getSourcePageFromQueryParam, loggerConfig, newi18instance, redirectTo, useScrollLock, useTitle, useWindowDimensions };
//# sourceMappingURL=myhr-ui-commons.esm.js.map
